<template>
  <div class="v-select">
    <div class="select-input" @click.stop="showMenu = !showMenu">
      <template v-if="single">
        <template v-if="selected">
          <span>{{selected[0].title}}</span>
        </template>
        <template v-else>{{placeholder}}</template>
      </template>
      <template v-else>
        <template v-if="selected.length === 0">{{placeholder}}</template>
        <template v-else>
          <span>{{selected[0].title}}</span>
          <template v-if="selected.length > 1">
            <span>+{{selected.length - 1}}</span>
          </template>
        </template>
      </template>
      <svg :class="{ 'dropdown-icon': true, active: showMenu}" style="width: 12px; height: 12px; vertical-align: middle; fill: currentcolor; overflow: hidden; font-size: 32px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M508.274081 759.889804c-10.64636 0-21.194426-4.354584-29.713152-13.016654L75.565809 334.344633c-14.80743-15.146336-14.80743-43.405571 0-58.600028 14.80743-15.195482 42.391924-15.195482 57.294575 0L510.403763 662.190667 887.947142 275.744605c14.806406-15.195482 42.388852-15.195482 57.292527 0 14.80743 15.194458 14.80743 43.453693 0 58.600028L537.887917 749.050954c-8.417361 6.484266-16.936087 10.83885-29.613836 10.83885z m0 0">
        </path>
      </svg>
    </div>
    <div v-if="showMenu" @click.stop="stopProp" class="select-dropdown">
      <div class="select-dropdown__wrapper">
        <div v-if="filterable" class="search-panel">
          <input type="text" v-model="query" @keyup="remoteSearch" class="select-input" placeholder="请输入关键字查询">
        </div>
        <div class="select-dropdown__list" :style="{minHeight: selected.length > 0 ? '200px' : 'auto'}" ref="list">
          <p v-if="options.length === 0" style="margin: 8px 0; text-align: center; font-size: 13px;">暂无数据</p>
          <ul v-else>
            <li v-for="(option, index) of options"
              @click="select(option)"
              :key="option.title+index"
              :title="option.title"
              :class="{'select-dropdown__item': true, active: selected.filter(item => item.title === option.title).length > 0}">
              <svg style="width: 12px; height: 12px; vertical-align: middle; fill: currentcolor; overflow: hidden; font-size: 32px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M378.4 850.464c-13.92 0-27.808-5.152-38.368-15.52L20.928 523.52c-21.216-20.704-21.216-54.24 0-74.944s55.552-20.704 76.768 0l280.736 273.952L925.792 188.48a55.2 55.2 0 0 1 76.768 0 52.032 52.032 0 0 1 0 74.912L416.832 834.944a54.784 54.784 0 0 1-38.368 15.52z" fill="#5cc8f7" p-id="4056"></path>
              </svg>
              {{option.title}}
            </li>
          </ul>
        </div>
        <template v-if="!single">
          <div class="select-dropdown__footer">
            <a v-if="selected.length > 0" @click="showSelected = true" href="javascript: void(0);">查看已选</a>&nbsp;
            <a @click="clear" href="javascript: void(0);">清除已选</a>&nbsp;
            <a @click="selectAll" href="javascript: void(0);">全选</a>
          </div>
          <div v-if="showSelected" class="select-dropdown__selected">
            <p v-if="selected && selected.length === 0" class="no-data">暂无选择项</p>
            <ul v-else class="selected-menu">
              <li v-for="(item, index) of selected" :key="item.title + index">
                {{item.title}}
                <a @click="remove(item)" href="javascript: void(0);">
                  <svg t="1541043642996" class="icon" style="width: 1em; height: 1em; vertical-align: middle; fill: currentcolor; overflow: hidden; font-size: 16px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3909"><path d="M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m493.248 0l135.744-135.744a32.32 32.32 0 0 0 0-45.248 32.32 32.32 0 0 0-45.248 0L512 466.688l-135.744-135.68a32.32 32.32 0 0 0-45.248 0 32.32 32.32 0 0 0 0 45.248L466.688 512l-135.68 135.744a32.32 32.32 0 0 0 0 45.248c12.16 12.16 32.768 12.544 45.248 0L512 557.312l135.744 135.68c12.16 12.16 32.768 12.544 45.248 0a32.32 32.32 0 0 0 0-45.248L557.312 512z" fill="#8a8a8a" data-spm-anchor-id="a313x.7781069.0.i3"></path></svg>
                </a>
              </li>
            </ul>
            <p class="select-dropdown__selected__back">
              <a @click="showSelected = false" href="javascript: void(0);">返回列表</a>
            </p>
          </div>
        </template>
        <div v-if="loading" class="select-dropdown__mask">
          <div class="loading-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [Object, Array],
    single: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    filterable: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    remote: {
      type: Function
    }
  },
  data() {
    return {
      showMenu: false,
      showSelected: false,
      selected: [],
      query: '',
      remoteSearchTimer: null,
      loading: false
    };
  },
  watch: {
    value() {
      if (this.single) {
        this.selected = [this.value];
      } else {
        this.value.forEach((item) => {
          const options = this.options.filter((o) => {
            const flag = o.title === item.title;
            return flag;
          });
          const sameVal = this.selected.filter((o) => {
            const flag = o.title === item.title;
            return flag;
          });
          if (options.length > 0 && sameVal.length === 0) {
            this.selected.push(...options);
          }
        });
      }
    },
    showMenu() {
      if (this.showMenu) {
        document.addEventListener('click', this.documentClickEvent);
      } else {
        document.removeEventListener('click', this.documentClickEvent);
      }
    },
    selected() {
      if (this.single) {
        this.$emit('input', this.selected[0]);
      } else {
        this.$emit('input', this.selected);
      }
    },
    options() {
      if (this.$refs.list) {
        this.$refs.list.scrollTo(0, 0);
      }
      this.loading = false;
    }
  },
  mounted() {
    if (this.single) {
      this.selected = [this.value];
    }
  },
  methods: {
    select(item) {
      if (this.single) {
        this.selected = [item];
        return;
      }
      const index = this.selected.indexOf(item);
      const flag = this.selected.some(element => element.title === item.title);
      if (flag) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(item);
      }
    },
    remoteSearch() {
      if (this.remoteSearchTimer) {
        clearTimeout(this.remoteSearchTimer);
      }
      this.remoteSearchTimer = setTimeout(() => {
        this.loading = true;
        this.remote(this.query).then(() => {
          this.loading = false;
        });
      }, 800);
    },
    selectAll() {
      this.options.forEach((item) => {
        if (this.selected.indexOf(item) === -1) {
          this.selected.push(item);
        }
      });
    },
    remove(item) {
      const index = this.selected.indexOf(item);
      this.selected.splice(index, 1);
    },
    clear() {
      this.selected = [];
    },
    documentClickEvent() {
      // console.warn('zhixing');
      this.showMenu = false;
      this.showSelected = false;
    },
    stopProp() {}
  }
};
</script>
<style scoped>
.v-select {
  box-sizing: border-box;
  position: relative;
  text-align: left;
}
.v-select .select-input {
  position: relative;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #c9cdd3;
  display: inline-block;
  font-size: 13px;
  outline: none;
  padding: 0 15px 0 5px;
  padding-right: 30px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 100%;
  cursor: pointer;
  overflow: hidden;
}
.v-select .select-input:focus {
  outline: none;
  border-color: #5cc8f7;
}
.v-select .select-input span {
  display: inline-block;
  padding: 2px 5px;
  margin: 2px 0 2px 6px;
  font-size: 12px;
  box-sizing: border-box;
  border-color: transparent;
  border-radius: 4px;
  background-color: #f0f2f5;
  line-height: 1;
  color: #909399;
  vertical-align: text-bottom;
}
.v-select .select-input span:first-child {
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-select .select-input .dropdown-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  transition: all .3s ease;
}
.v-select .select-input .dropdown-icon.active {
  transform: rotate(-180deg);
}
.v-select .select-dropdown {
  box-sizing: border-box;
  margin: 5px 0;
  /* width: 100%; */
  max-width: 120%;
  min-width: 100%;
  position: absolute;
  transform-origin: center top 0px;
  z-index: 2009;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  overflow-y: auto;
}
.v-select .select-dropdown .select-dropdown__wrapper {
  display: flex;
  height: 100%;
  position: relative;
  flex-direction: column;
}
.v-select .select-dropdown .select-dropdown__wrapper .search-panel {
  box-sizing: border-box;
  padding: 5px;
  width: 100%;
  flex: 0 0;
}
.v-select .select-dropdown .select-dropdown__wrapper .search-panel .select-input {
  color: #333;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__list {
  flex: 1 0;
  max-height: 300px;
  overflow-y: auto;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__list ul {
  margin: 0;
  padding-left: 0;
  list-style: none;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__list ul .select-dropdown__item,
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected .selected-menu li {
    font-size: 14px;
    padding: 0 24px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    cursor: pointer;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__list ul .select-dropdown__item> svg {
  display: none;
  position: absolute;
  left: 4px;
  top: 10px;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__list ul .select-dropdown__item.active {
  font-weight: 600;
  color: #5cc8f7;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__list ul .select-dropdown__item.active > svg {
  display: inline;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdowm__list ul .select-dropdowm__item:hover {
  background-color: #f5f7fa;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__footer {
  flex: 0 0;
  padding: 5px 8px;
  text-align: right;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__footer a {
  font-size: 12px;
  color: #409eff;
  text-decoration: none;
  cursor: pointer;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected {
  position: absolute;
  padding-bottom: 40px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, .9);
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected .selected-menu {
  /* padding: 10px 0; */
  overflow: auto;
  height: 100%;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected .selected-menu li {
  position: relative;
  padding: 0 30px 0 10px;
  font-weight: 500;
  color: #5cc8f7;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected .selected-menu li a {
  position: absolute;
  right: 15px;
  cursor: pointer;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected .no-data {
  padding: 10px 0;
  text-align: center;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected .select-dropdown__selected__back {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 5px;
  text-align: center;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__selected .select-dropdown__selected__back a {
  color: #409eff;
  font-size: 12px;
  text-decoration: none;
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__mask {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, .5);
}
.v-select .select-dropdown .select-dropdown__wrapper .select-dropdown__mask .loading-icon{
  position: absolute;
  left: 46%;
  top: 46%;
  border-radius: 100%;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  border: 2px solid #5cc8f7;
  background-color: #5cc8f7;
  border-bottom-color: transparent;
  height: 35px;
  width: 35px;
  background: transparent !important;
  display: inline-block;
  -webkit-animation: rotate 0.75s 0s linear infinite;
  animation: rotate 0.75s 0s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select.vue